import React from 'react';
import { observer } from 'mobx-react';
import { BlueprintsNavigation } from '../shared/blueprints-navigation';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../api/roles.dao';
import DefaultButton from '../../global/default-button/default-button';
import { ITheadSort, ListLayout } from '../../global/tables/table-list-layout';
import { TGetReportsSortKeys } from '../../../api/reports.dao';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { MeetingTemplatesVM } from './meeting-templates.viewmodel';
import { MeetingTemplatesListItem } from './meeting-templates-list-item/meeting-templates-list-item';
import './meeting-templates.scss';
import BluePrintItemDetailsPopover from '../blueprint-item-details-popover/blueprint-item-details-popover';
import { DESCRIPTION } from '../../../constants/common-labels.constants';


type Props = {
    vm: MeetingTemplatesVM;
};
export const MeetingTemplatesPresentation = observer((props: Props): JSX.Element => {

    const { vm } = props;
    const { intl } = vm;

    const isListEmpty = !vm.isLoading && !vm.meetingTemplates.length;


    const tHeads: ITheadSort<TGetReportsSortKeys>[] = [
        {
            title: intl.formatMessage({
                id: 'oe.blueprints.name',
                defaultMessage: 'Name',
                description: 'Label text'
            }),
        },
        {
            title: intl.formatMessage({
                id: 'oe.blueprints.dateCreated',
                defaultMessage: 'Date Created',
                description: 'Label text'
            }),
        },
        {
            title: intl.formatMessage(DESCRIPTION),
        },
        {
            width: '150px'
        }
    ];

    return (
        <div className='event-blueprints'>
            <section className='horizontal-row horizontal-row--with-bottom-margin event-tabs'>
                <BlueprintsNavigation />
                <div className='horizontal-row__align-to-row-end'>
                    <div className='buttons-block'>
                        {hasPermission(Permission.CREATE_MEETING_TEMPLATES) &&
                            <DefaultButton
                                modifier={['fat', 'confirm-safe']}
                                text={intl.formatMessage({
                                    id: 'oe.blueprints.newMeetingTemplate',
                                    defaultMessage: '+ New Meeting Template',
                                    description: 'Button label'
                                })}
                                onClick={vm.openCreateTemplateForm.bind(vm)}
                            />
                        }
                    </div>
                </div>
            </section>
            <section className='fixed-list-layout'>
                <div>
                    <ListLayout sortOptions={{ theads: tHeads }}>
                        {vm.isLoading && <TableLoadingRow colSpan={tHeads.length} />}
                        {isListEmpty &&
                            <tr>
                                <td className='table-loading' colSpan={tHeads.length}>
                                    {intl.formatMessage({
                                        id: 'oe.blueprints.noMeetingTemplates',
                                        defaultMessage: 'No Meeting Templates have been created in this account.',
                                        description: 'Placeholder text'
                                    })}
                                </td>
                            </tr>
                        }
                        {!vm.isLoading && vm.meetingTemplates.map(item => {
                            return <MeetingTemplatesListItem
                                openTemplateDetails={vm.openMeetingTemplateDetails}
                                isSelected={vm.isTemplateSelected(item.blueprintId)}
                                key={item.blueprintId}
                                item={item}
                                intl={intl}
                                openEditModal={vm.editConnectionTemplate.bind(vm, item.blueprintId)}
                            />;
                        })}
                    </ListLayout>
                </div>
            </section>
            <BluePrintItemDetailsPopover
                title={intl.formatMessage({
                    id: 'oe.blueprint.details.viewMeetingTemplateDetails',
                    defaultMessage: 'View Meeting Template Details',
                    description: 'Popover title'
                })}
                template={vm.selectedTemplate}
                closePopover={vm.closeBluePrintItemDetailsPopover}
            />
        </div>
    );
});
